import type { Translations } from './en.js';

const id: Translations = {
  ok: 'OK', cancel: 'Batal', close: 'Tutup', confirm: 'Konfirmasi', retry: 'Coba lagi', back: 'Kembali', settings: 'Pengaturan', language: 'Bahasa',
  score: 'Skor', level: 'Level', game_over: 'Game Over', restart: 'Mulai Ulang', pause: 'Jeda', resume: 'Lanjutkan',
  settings_sound: 'Suara', settings_music: 'Musik', settings_reset: 'Reset Game', settings_reset_confirm: 'Reset semua progress?',
  ad_watch: 'Tonton Iklan', ad_reward: 'Hadiah Gratis', ad_loading: 'Memuat iklan...', ad_reward_received: 'Hadiah diterima!', ad_not_completed: 'Iklan belum selesai',
  offline_title: 'Selamat Datang Kembali!', offline_earned: 'Diperoleh saat offline',
  sp: 'SP', fame: 'Ketenaran', building_tab: 'Bangunan', ghosts_tab: 'Hantu', shop_tab: 'Toko', prestige_tab: 'Prestise',
  training_tab: 'Latihan', facilities_tab: 'Fasilitas', reviews_tab: 'Ulasan',
  floor_label: 'Lantai {n}', buy_floor: 'Beli Lantai', buy_floor_cost: 'Beli Lantai ({sp} SP)', unlock_slot: 'Buka Slot', unlock_slot_cost: 'Buka Slot ({sp} SP)',
  build_room: 'Bangun Ruangan', upgrade_room: 'Tingkatkan Ruangan', upgrade_room_cost: 'Tingkatkan ({sp} SP)', room_empty: 'Kosong', room_locked: 'Terkunci',
  no_ghost: 'Tidak ada hantu', assign_ghost: 'Tugaskan Hantu', visitors_floor: 'Pengunjung di lantai ini',
  add_floor: 'Tambah Lantai', add_floor_cost: '+ Lantai Baru ({sp} SP)', menu_tab: 'Menu',
  room_dark_corridor: 'Lorong Gelap', room_dark_corridor_desc: 'Ketakutan psikologis +30%',
  room_mirror_room: 'Ruangan Cermin', room_mirror_room_desc: 'Visual +25%, Psikologis +15%',
  room_dungeon: 'Penjara Bawah Tanah', room_dungeon_desc: 'Psikologis +20%, Fisik +20%',
  room_graveyard: 'Ruangan Kuburan', room_graveyard_desc: 'Ketakutan psikologis +40%',
  room_lab: 'Laboratorium', room_lab_desc: 'Visual +30%, Fisik +20%',
  room_library: 'Perpustakaan', room_library_desc: 'Psikologis +35%, Pendengaran +15%',
  room_coffin_room: 'Ruangan Peti Mati', room_coffin_room_desc: 'Visual +30%, Psikologis +20%',
  room_doll_room: 'Ruangan Boneka', room_doll_room_desc: 'Visual +20%, Psikologis +35%',
  room_kitchen: 'Dapur Terkutuk', room_kitchen_desc: 'Fisik +30%, Pendengaran +20%',
  room_bathroom: 'Kamar Mandi Berhantu', room_bathroom_desc: 'Psikologis +30%, Pendengaran +25%',
  room_funhouse: 'Rumah Cermin',
  room_funhouse_desc: 'Visual+35%, Psikologis+20%',
  room_trapeze_room: 'Ruang Trapeze',
  room_trapeze_room_desc: 'Fisik+30%, Visual+15%',
  room_freak_show: 'Pertunjukan Ajaib',
  room_freak_show_desc: 'Visual+40%, Psikologis+30%',
  room_sacrifice_altar: 'Altar Korban',
  room_sacrifice_altar_desc: 'Psikologis+40%, Visual+20%',
  room_treasure_vault: 'Brankas Harta',
  room_treasure_vault_desc: 'Psikologis+20%, Auditori+20%',
  room_underground_river: 'Sungai Bawah Tanah',
  room_underground_river_desc: 'Auditori+30%, Psikologis+20%',
  room_curse_chamber: 'Ruang Kutukan',
  room_curse_chamber_desc: 'Psikologis+45%, Fisik+15%',
  room_mummy_tomb: 'Makam Mummi',
  room_mummy_tomb_desc: 'Visual+30%, Psikologis+30%',
  room_captain_cabin: 'Kabin Kapten',
  room_captain_cabin_desc: 'Psikologis+30%, Visual+20%',
  room_cargo_hold: 'Ruang Kargo',
  room_cargo_hold_desc: 'Fisik+25%, Auditori+20%',
  room_davy_jones_locker: 'Loker Davy Jones',
  room_davy_jones_locker_desc: 'Psikologis+35%, Visual+25%',
  room_brig: 'Sel Kapal',
  room_brig_desc: 'Fisik+30%, Psikologis+20%',
  room_crows_nest: 'Sarang Gagak',
  room_crows_nest_desc: 'Fisik+35%, Visual+20%',
  room_mine_shaft: 'Lubang Tambang',
  room_mine_shaft_desc: 'Fisik+30%, Auditori+20%',
  room_crystal_cave: 'Gua Kristal',
  room_crystal_cave_desc: 'Visual+35%, Auditori+15%',
  room_explosives_storage: 'Gudang Bahan Peledak',
  room_explosives_storage_desc: 'Fisik+40%, Auditori+25%',
  room_underground_lake: 'Danau Bawah Tanah',
  room_underground_lake_desc: 'Psikologis+30%, Auditori+25%',
  room_rail_tunnel: 'Terowongan Rel',
  room_rail_tunnel_desc: 'Fisik+30%, Psikologis+20%',
  room_throne_room: 'Ruang Tahta',
  room_throne_room_desc: 'Visual+25%, Psikologis+30%',
  room_wine_cellar: 'Gudang Anggur',
  room_wine_cellar_desc: 'Psikologis+30%, Visual+15%',
  room_tower_chamber: 'Ruang Menara',
  room_tower_chamber_desc: 'Psikologis+35%, Fisik+20%',
  room_server_room: 'Ruang Server',
  room_server_room_desc: 'Auditori+30%, Visual+20%',
  room_quarantine_zone: 'Zona Karantina',
  room_quarantine_zone_desc: 'Psikologis+35%, Fisik+20%',
  room_armory: 'Gudang Senjata',
  room_armory_desc: 'Fisik+35%, Visual+20%',
  room_witch_hut: 'Gubuk Penyihir',
  room_witch_hut_desc: 'Visual+30%, Psikologis+25%',
  room_treehouse: 'Rumah Pohon',
  room_treehouse_desc: 'Fisik+25%, Auditori+20%',
  room_swamp_path: 'Jalan Rawa',
  room_swamp_path_desc: 'Psikologis+30%, Auditori+20%',
  room_fairy_ring: 'Lingkaran Peri',
  room_fairy_ring_desc: 'Psikologis+40%, Visual+20%',
  room_ancient_ruin: 'Reruntuhan Kuno',
  room_ancient_ruin_desc: 'Psikologis+35%, Visual+25%',
  room_attic: 'Loteng',
  room_attic_desc: 'Psikologis+30%, Auditori+15%',
  room_secret_passage: 'Lorong Rahasia',
  room_secret_passage_desc: 'Psikologis+35%, Fisik+15%',
  room_morgue: 'Ruang Jenazah',
  room_morgue_desc: 'Visual+30%, Psikologis+30%',
  room_surgery_room: 'Ruang Operasi',
  room_surgery_room_desc: 'Fisik+35%, Visual+25%',
  room_music_room: 'Ruang Musik',
  room_music_room_desc: 'Auditori+40%, Psikologis+20%',
  room_science_lab: 'Lab Sains',
  room_science_lab_desc: 'Visual+30%, Fisik+25%',
  room_ticket_booth: 'Loket Tiket',
  room_ticket_booth_desc: 'Psiko+25%, Visual+20%',
  room_animal_cage: 'Kandang Hewan',
  room_animal_cage_desc: 'Fisik+30%, Visual+25%',
  room_clown_tent: 'Tenda Badut',
  room_clown_tent_desc: 'Psiko+40%, Visual+20%',
  room_hall_of_mirrors: 'Ruang Cermin',
  room_hall_of_mirrors_desc: 'Visual+40%, Psiko+30%',
  room_elevator_shaft: 'Lubang Lift',
  room_elevator_shaft_desc: 'Fisik+35%, Psiko+20%',
  room_ore_processing: 'Pengolahan Bijih',
  room_ore_processing_desc: 'Auditori+30%, Fisik+20%',
  room_collapsed_tunnel: 'Terowongan Runtuh',
  room_collapsed_tunnel_desc: 'Fisik+40%, Psiko+25%',
  room_miners_quarters: 'Barak Penambang',
  room_miners_quarters_desc: 'Psiko+30%, Visual+20%',
  room_command_center: 'Pusat Komando',
  room_command_center_desc: 'Psiko+30%, Auditori+25%',
  room_ventilation_shaft: 'Saluran Ventilasi',
  room_ventilation_shaft_desc: 'Fisik+35%, Auditori+25%',
  room_decontamination: 'Dekontaminasi',
  room_decontamination_desc: 'Psiko+35%, Visual+25%',
  room_hollow_tree: 'Pohon Berongga',
  room_hollow_tree_desc: 'Visual+30%, Psiko+25%',
  room_spider_nest: 'Sarang Laba-laba',
  room_spider_nest_desc: 'Visual+35%, Fisik+25%',
  room_moonlit_clearing: 'Padang Cahaya Bulan',
  room_moonlit_clearing_desc: 'Psiko+40%, Auditori+20%',
  room_abandoned_cabin: 'Pondok Terbengkalai',
  room_abandoned_cabin_desc: 'Psiko+30%, Visual+20%',

  room_ward_room: 'Bangsal',
  room_ward_room_desc: 'Psiko+30%, Visual+20%',
  room_reception_hall: 'Resepsionis',
  room_reception_hall_desc: 'Psiko+25%, Audio+20%',
  room_x_ray_room: 'Ruang X-Ray',
  room_x_ray_room_desc: 'Visual+35%, Fisik+20%',
  room_classroom: 'Ruang Kelas',
  room_classroom_desc: 'Psiko+30%, Audio+15%',
  room_art_room: 'Ruang Seni',
  room_art_room_desc: 'Visual+35%, Psiko+20%',
  room_gymnasium: 'Gimnasium',
  room_gymnasium_desc: 'Fisik+30%, Audio+25%',
  room_rooftop: 'Atap',
  room_rooftop_desc: 'Psiko+40%, Fisik+20%',
  room_crypt: 'Ruang Bawah Tanah',
  room_crypt_desc: 'Visual+35%, Psiko+25%',
  room_powder_room: 'Gudang Mesiu',
  room_powder_room_desc: 'Fisik+40%, Audio+20%',
  room_navigation_room: 'Ruang Navigasi',
  room_navigation_room_desc: 'Psiko+30%, Visual+20%',
  room_banquet_hall: 'Ruang Perjamuan',
  room_banquet_hall_desc: 'Psiko+30%, Visual+20%',
  room_chapel: 'Kapel',
  room_chapel_desc: 'Psiko+40%, Audio+20%',
  room_torture_chamber: 'Ruang Penyiksaan',
  room_torture_chamber_desc: 'Fisik+40%, Visual+30%',
  room_armory_hall: 'Ruang Senjata',
  room_armory_hall_desc: 'Fisik+30%, Visual+25%',
  room_science_room: 'Ruang Riset',
  room_science_room_desc: 'Visual+30%, Psiko+20%',

  unlock_requires_day: 'Hari {n}+',
  unlock_requires_fame: 'Fama {n}+',
  unlock_requires_room: 'Butuh: {name}',
  unlock_condition_not_met: 'Syarat belum terpenuhi',
  room_repair_needed: 'Perlu diperbaiki', room_repairing: 'Sedang diperbaiki', room_cleaning: 'Sedang dibersihkan',
  ghost_roster: 'Daftar Hantu', ghost_idle: 'Tidak aktif', ghost_assigned: 'Ditugaskan', ghost_fatigue: 'Kelelahan',
  ghost_level: 'Lv.{n}', ghost_exp: 'EXP {cur}/{max}', ghost_level_up: 'Naik Level',
  recover_fatigue: 'Pulihkan Kelelahan ({sp} SP)', ghost_fatigued_warning: 'Kelelahan! Efisiensi -50%', unassign_ghost: 'Batalkan Tugas',
  ghost_training_in_progress: 'Berlatih...',
  shop_ghosts: 'Rekrut Hantu', shop_rooms: 'Jenis Ruangan', hire: 'Rekrut', hire_cost: '{sp} SP', already_hired: 'Sudah Direkrut',
  not_enough_sp: 'SP tidak cukup!', unlock_room_type: 'Buka', unlock_cost: '{sp} SP', already_unlocked: 'Sudah Dibuka',
  grade_c: 'Kelas C', grade_b: 'Kelas B', grade_a: 'Kelas A', grade_s: 'Kelas S',
  ghost_jinaeryeong: 'Hantu Wanita Korea', ghost_gangsi: 'Jiangshi', ghost_vampire: 'Vampir', ghost_kappa: 'Kappa', ghost_pierrot: 'Badut', ghost_banshee: 'Banshee',
  ghost_origin_korea: 'Korea', ghost_origin_china: 'China', ghost_origin_romania: 'Rumania', ghost_origin_japan: 'Jepang', ghost_origin_usa: 'AS', ghost_origin_ireland: 'Irlandia',
  ghost_jinaeryeong_skill: 'Rambut Jatuh: jatuh dari langit-langit menambah ketakutan fisik',
  ghost_gangsi_skill: 'Lompat Kaku: melompat dengan kaku menakuti 2 pengunjung sekaligus',
  ghost_vampire_skill: 'Mata Hipnosis: membekukan 1 pengunjung 10 detik, ruangan berikutnya +30%',
  ghost_kappa_skill: 'Putar Piring: memutar piring di kepala untuk ketakutan visual',
  ghost_pierrot_skill: 'Serangan Tawa: muncul tiba-tiba, ketakutan badut',
  ghost_banshee_skill: 'Jeritan: ketakutan pendengaran maksimal, bisa aktif berulang kali',
  ghost_jinaeryeong_quote: 'Hari ini menakuti 10 pengunjung, bos!', ghost_gangsi_quote: 'Melompat-lompat itu susah...',
  ghost_vampire_quote: 'Malam panjang dan aku abadi.', ghost_kappa_quote: 'Jangan tumpahkan airnya!',
  ghost_pierrot_quote: 'Kenapa serius sekali?', ghost_banshee_quote: 'Tenggorokanku sakit karena terlalu banyak berteriak.',
  ghost_jinaeryeong_fatigued: 'Bos... rambutku berantakan. Aku perlu istirahat!',
  ghost_gangsi_fatigued: 'Aku tidak bisa bergerak lagi... secara harfiah.', ghost_vampire_fatigued: 'Bahkan yang abadi pun butuh istirahat...',
  ghost_kappa_fatigued: 'Piringku kering, butuh air!', ghost_pierrot_fatigued: 'Aku tidak bisa tertawa lagi, bos.',
  ghost_banshee_fatigued: 'Suaraku hilang! Tidak bisa berteriak!',
  room_unlock_in_shop: 'Buka di toko',
  visitor_scaredy_kid: 'Anak Penakut', visitor_scaredy_kid_desc: 'Mudah takut tapi puas dengan sedikit',
  visitor_normal: 'Pengunjung', visitor_normal_desc: 'Toleransi ketakutan rata-rata',
  visitor_brave: 'Pemberani', visitor_brave_desc: 'Toleransi tinggi, hadiah besar saat puas',
  visitor_couple: 'Pasangan', visitor_couple_desc: 'Takut sedang, hadiah tinggi, ulasan baik',
  visitor_youtuber: 'Youtuber', visitor_youtuber_desc: 'Ulasan berpengaruh 2.5x terhadap ketenaran',
  visitor_exorcist: 'Pengusir Setan', visitor_exorcist_desc: 'Hampir tidak mungkin ditakuti, hadiah besar',
  visitor_thrill_seeker: 'Pencari Sensasi', visitor_thrill_seeker_desc: 'Ingin ketakutan intens, tidak sabar dengan yang lemah',
  visitor_coward: 'Pengecut', visitor_coward_desc: 'Takut segalanya, mudah kabur',
  time_phase_day: 'Siang', time_phase_evening: 'Sore', time_phase_night: 'Malam', time_phase_rain: 'Hujan',
  reputation_label: 'Rep: {n}',
  scare_chain: 'Rantai x{n}!', terror_max: 'TEROR MAKSIMAL!', sp_earned: '+{sp} SP',
  prestige_title: 'Ekspansi Waralaba', prestige_desc: 'Rumah hantu Anda terkenal di dunia! Buka waralaba?',
  prestige_requirement_floors: 'Membutuhkan {n} lantai', prestige_requirement_fame: 'Membutuhkan Ketenaran {n}',
  prestige_requirement_sp: 'Membutuhkan total SP {n}', prestige_not_ready: 'Persyaratan belum terpenuhi',
  prestige_confirm: 'Buka Waralaba', prestige_level: 'Prestise Lv.{n}',
  prestige_bonus: 'Semua hantu +{n}% ketakutan, SP awal +{sp}', offline_collect: 'Ambil',

  training_title: 'Kelas Akting', training_select: 'Pilih Latihan', training_cost: '{sp} SP', training_duration: '{sec} detik',
  training_in_progress: 'Sedang berlatih...', training_complete: 'Latihan Selesai!', training_bonus: 'Ketakutan +{pct}%',
  training_skip_ad: 'Lewati (Iklan)', training_count: '{n} sesi selesai', training_ghost_busy: 'Batalkan tugas hantu terlebih dahulu', training_already: 'Sudah berlatih',
  training_scream_practice: 'Latihan Berteriak', training_scream_practice_desc: 'Tingkatkan proyeksi suara dan timing',
  training_jumpscare_acting: 'Akting Jumpscare', training_jumpscare_acting_desc: 'Kuasai seni kemunculan mendadak',
  training_psychological_acting: 'Horor Psikologis', training_psychological_acting_desc: 'Pelajari cara menciptakan ketakutan berkepanjangan',
  training_atmosphere_directing: 'Pengaturan Atmosfer', training_atmosphere_directing_desc: 'Kontrol pencahayaan, suara, dan kabut',
  training_physical_training: 'Latihan Fisik', training_physical_training_desc: 'Bangun stamina untuk menakuti yang energik',
  training_audience_analysis: 'Analisis Penonton', training_audience_analysis_desc: 'Pelajari perilaku pengunjung untuk ketakutan optimal',

  tq_jinaeryeong_scream: 'Hantu Wanita Korea menganalisis film horor di YouTube...',
  tq_gangsi_scream: 'Jiangshi berlatih berteriak dalam posisi kaku...',
  tq_vampire_scream: 'Vampir bersenandung opera di ruang bawah tanah...',
  tq_kappa_scream: 'Kappa berlatih teriakan bawah air di ember...',
  tq_pierrot_scream: 'Badut berteriak ke balon...', tq_banshee_scream: 'Banshee mengajar masterclass untuk pemula...',
  tq_jinaeryeong_jumpscare: 'Hantu Wanita Korea berulang kali melompat dari lemari...',
  tq_gangsi_jumpscare: 'Jiangshi peregangan sebelum latihan lompat...',
  tq_vampire_jumpscare: 'Vampir berlatih pembukaan jubah dramatis...',
  tq_kappa_jumpscare: 'Kappa muncul dari toilet...', tq_pierrot_jumpscare: 'Badut latihan timing ledakan balon...',
  tq_banshee_jumpscare: 'Banshee mengerjakan koreografi masuk panggung...',
  tq_jinaeryeong_psych: 'Hantu Wanita Korea membaca buku psikologi...',
  tq_gangsi_psych: 'Jiangshi mencoba terlihat menyeramkan (sudah begitu)...',
  tq_vampire_psych: 'Vampir berlatih di depan cermin... (tidak terlihat)',
  tq_kappa_psych: 'Kappa belajar ketakutan manusia dari buku perpustakaan...',
  tq_pierrot_psych: 'Badut menonton "It" untuk ke-50 kalinya...', tq_banshee_psych: 'Banshee menulis skrip bisikan menyeramkan...',
  tq_jinaeryeong_atmo: 'Hantu Wanita Korea menata rambut untuk efek maksimal...',
  tq_gangsi_atmo: 'Jiangshi menyesuaikan pengaturan mesin kabut...',
  tq_vampire_atmo: 'Vampir memilih sudut lilin yang sempurna...',
  tq_kappa_atmo: 'Kappa menguji berbagai suara tetesan air...',
  tq_pierrot_atmo: 'Badut mengecat dinding dengan cat fosfor...',
  tq_banshee_atmo: 'Banshee mengkalibrasi efek gema di lorong...',
  tq_jinaeryeong_physical: 'Hantu Wanita Korea latihan merangkak di langit-langit...',
  tq_gangsi_physical: 'Jiangshi squat dengan kaki kaku...',
  tq_vampire_physical: 'Vampir push-up di dalam peti mati...',
  tq_kappa_physical: 'Kappa berenang lap di kolam...',
  tq_pierrot_physical: 'Badut sit-up sambil juggling...',
  tq_banshee_physical: 'Banshee pemanasan pita suara...',
  tq_jinaeryeong_audience: 'Hantu Wanita Korea membaca ulasan pengunjung online...',
  tq_gangsi_audience: 'Jiangshi mempelajari pola alur pengunjung...',
  tq_vampire_audience: 'Vampir menganalisis demografi ketakutan...',
  tq_kappa_audience: 'Kappa mensurvei kelompok usia yang takut air...',
  tq_pierrot_audience: 'Badut melacak statistik coulrophobia...',
  tq_banshee_audience: 'Banshee mempelajari respons ketakutan terhadap frekuensi suara...',

  props_title: 'Dekorasi Ruangan', prop_buy: 'Beli ({sp} SP)', prop_upgrade: 'Tingkatkan ({sp} SP)', prop_max: 'MAKS', prop_level: 'Lv.{n}', prop_bonus: '+{pct}% ketakutan',
  prop_cobwebs: 'Sarang Laba-laba', prop_cobwebs_desc: 'Suasana seram klasik',
  prop_candles: 'Lilin Berkedip', prop_candles_desc: 'Bayangan menari yang seram',
  prop_blood_pool: 'Genangan Darah', prop_blood_pool_desc: 'Dekorasi lantai yang mengerikan',
  prop_skull_decor: 'Dekorasi Tengkorak', prop_skull_decor_desc: 'Pajangan menggigil tulang',
  prop_fog_machine: 'Mesin Kabut', prop_fog_machine_desc: 'Kabut tebal misterius',
  prop_creaky_floor: 'Lantai Berderit', prop_creaky_floor_desc: 'Setiap langkah berbunyi',
  prop_eerie_painting: 'Lukisan Seram', prop_eerie_painting_desc: 'Mata yang mengikuti',
  prop_chains: 'Rantai Berderak', prop_chains_desc: 'Suara logam menghantui',

  // Staging Equipment
  prop_dry_ice: 'Mesin Es Kering', prop_dry_ice_desc: 'Menciptakan kabut tebal untuk suasana seram',
  prop_scent_sprayer: 'Penyemprot Aroma', prop_scent_sprayer_desc: 'Melepas bau mengerikan untuk imersi horor',
  prop_strobe_light: 'Lampu Strobo', prop_strobe_light_desc: 'Kilatan cahaya membingungkan pengunjung',
  prop_surround_speaker: 'Speaker Surround', prop_surround_speaker_desc: 'Audio spasial untuk efek suara menakutkan',
  prop_vibration_floor: 'Panel Lantai Getar', prop_vibration_floor_desc: 'Getaran tiba-tiba di bawah kaki',
  prop_temp_controller: 'Pengatur Suhu', prop_temp_controller_desc: 'Hembusan udara dingin untuk teror psikologis',
  prop_hologram_device: 'Perangkat Hologram', prop_hologram_device_desc: 'Memproyeksikan penampakan hantu',
  prop_auto_lock: 'Kunci Pintu Otomatis', prop_auto_lock_desc: 'Pintu terkunci tiba-tiba di belakang pengunjung',
  props_category_decoration: 'Dekorasi', props_category_staging: 'Peralatan Pementasan',
  props_staging_desc: 'Peralatan canggih untuk efek horor profesional',

  facilities_title: 'Fasilitas Tambahan', facility_build: 'Bangun ({sp} SP)', facility_upgrade: 'Tingkatkan ({sp} SP)',
  facility_level: 'Lv.{n}', facility_built: 'Terbangun',
  facility_haunted_house: 'Rumah Hantu', facility_haunted_house_desc: 'Gedung utama pengalaman horor',
  facility_haunted_house_bonus: 'Pintu masuk gedung utama', facility_enter: 'Masuk',
  facility_ticket_booth: 'Loket Tiket', facility_ticket_booth_desc: 'Menjual tiket masuk kepada pengunjung', facility_ticket_booth_bonus: 'Meningkatkan kapasitas pengunjung maksimum', facility_ticket_booth_visitors: 'pengunjung',
  facility_gift_shop: 'Toko Suvenir', facility_gift_shop_desc: 'Jual suvenir rumah hantu',
  facility_gift_shop_bonus: '+{sp} SP per grup pengunjung',
  facility_snack_bar: 'Kantin', facility_snack_bar_desc: 'Makanan ringan dan minuman seram',
  facility_snack_bar_bonus: '+{pct}% hadiah pengunjung',
  facility_photo_booth: 'Booth Foto', facility_photo_booth_desc: 'Stasiun selfie teror',
  facility_photo_booth_bonus: '+{sp} SP per grup pengunjung',

  reviews_title: 'Ulasan Pengunjung', reviews_empty: 'Belum ada ulasan. Tunggu pengunjung!',
  reviews_fame_bonus: '+{n} Ketenaran', review_stars: '{n} bintang', reviews_avg: 'Rata-rata: {n} bintang',
  review_5_1: 'Benar-benar menakutkan! {ghost} di lantai 3 luar biasa!',
  review_5_2: 'Rumah hantu terbaik! Teriak sampai suara hilang!',
  review_5_3: 'Akting {ghost} layak Oscar! 10/10!',
  review_5_4: 'Jiwa hampir keluar. Sepadan!',
  review_4_1: '{ghost} cukup menakutkan, tapi berharap lebih dari lantai atas.',
  review_4_2: 'Atmosfer bagus! Hampir ngompol. Hampir.',
  review_4_3: '{ghost} mengesankan tapi timing bisa lebih baik.',
  review_4_4: 'Ketakutan solid. Akan direkomendasikan!',
  review_3_1: 'Lumayan. Beberapa ruangan kosong merusak suasana.',
  review_3_2: '{ghost} terlihat lelah hari ini. Istirahat dong?',
  review_3_3: 'Pengalaman rata-rata. Butuh lebih banyak dekorasi.',
  review_2_1: '{ghost} tidur saat kerja. Minta refund.',
  review_2_2: 'Lebih lucu daripada menakutkan. Hantu perlu les akting.',
  review_2_3: '{ghost} sudah berusaha tapi... sama sekali tidak menakutkan.',
  review_1_1: 'Ruangan kosong di mana-mana. Ini buka?',
  review_1_2: 'Mau uang kembali. Nenek saya lebih seram.',
  review_1_3: '{ghost} melambaikan tangan. MELAMBAIKAN. Itu bukan cara menghantui.',

  review_street_5star: 'Taman hiburan luar biasa! Rumah hantu sangat menyeramkan!', review_street_4star: 'Pengalaman bagus. Rumah hantu seram, makanannya enak.', review_street_3star: 'Lumayan. Rumah hantu perlu lebih banyak hantu.', review_street_2star: 'Tidak banyak yang bisa dilakukan. Rumah hantu biasa saja.', review_street_1star: 'Buang waktu. Tidak seram sama sekali.',

  review_vip_satisfied: 'VIP: Perfect! I will definitely come back with my friends.',
  review_vip_unsatisfied: 'VIP: Very disappointing experience. Not worth my time.',

  season_halloween: 'Halloween',
  season_summer_fest: 'Summer Fest',
  season_winter_chill: 'Winter Chill',
  season_spring_bloom: 'Spring Bloom',
  ad_sp_boost: 'SP 2x (30 detik)', ad_sp_boost_desc: 'Gandakan semua perolehan SP selama 30 detik',
  ad_recover_fatigue: 'Pemulihan Gratis', ad_recover_fatigue_desc: 'Pulihkan kelelahan hantu secara gratis',
  ad_vip_visitor: 'Pengunjung VIP', ad_vip_visitor_desc: 'Panggil grup pengunjung hadiah tinggi',
  ad_skip_training: 'Lewati Latihan', ad_skip_training_desc: 'Selesaikan latihan secara instan',
  ad_active_boost: 'SP 2x aktif!', ad_rewards_title: 'Hadiah Iklan',

  // === Business / Open-Close System ===
  day_label: 'Hari {n}',
  hud_operation_day: 'Hari ke-{n}',
  status_open: 'BUKA',
  status_closed: 'TUTUP',
  manage_business: 'Manage Business',
  toggle_open: 'Buka Bisnis',
  toggle_close: 'Tutup Bisnis',
  facility_open_badge: 'BUKA',
  need_ghost_to_open: 'Tempatkan hantu di ruangan terlebih dahulu!',
  ticket_price: 'Harga Tiket',
  ticket_price_label: '{n} SP',
  ticket_price_low: 'Lebih banyak pengunjung, lebih sedikit pendapatan per orang',
  ticket_price_high: 'Lebih sedikit pengunjung, lebih banyak pendapatan per orang',
  end_day: 'Akhiri Hari',
  day_summary_title: 'Ringkasan Hari {n}',
  day_summary_visitors: 'Pengunjung: {n}',
  day_summary_earnings: 'Pendapatan: {n} SP',
  day_summary_avg_rating: 'Rating rata-rata: {n}',
  day_summary_next: 'AKHIRI & KUMPULKAN',
  day_summary_best_visitor: 'Kunjungan {n} Bintang!',
  day_summary_sp_collected: 'TOTAL SP TERKUMPUL',
  day_summary_sp_gain: '+{n}',
  day_summary_milestones: 'TARGET HARIAN',
  day_summary_total_visits: 'TOTAL KUNJUNGAN',
  day_summary_reaction_5: 'MENGERIKAN!',
  day_summary_reaction_4: 'SANGAT MENYERAMKAN!',
  day_summary_reaction_3: 'LUMAYAN',
  day_summary_reaction_2: 'BIASA...',
  day_summary_reaction_1: 'MEMBOSANKAN...',

  milestone_visitors_5: 'Sambut {target} pengunjung',
  milestone_visitors_10: 'Sambut {target} pengunjung',
  milestone_visitors_20: 'Sambut {target} pengunjung',
  milestone_earnings_1000: 'Dapatkan {target} SP',
  milestone_earnings_5000: 'Dapatkan {target} SP',
  milestone_earnings_10000: 'Dapatkan {target} SP',
  milestone_flee_0: 'Nol pengunjung kabur',
  milestone_flee_1: 'Maks {target} pengunjung kabur',
  milestone_rooms_3: 'Operasikan {target}+ kamar',
  milestone_rooms_5: 'Operasikan {target}+ kamar',
  milestone_ghosts_2: 'Tempatkan {target}+ hantu',
  milestone_ghosts_3: 'Tempatkan {target}+ hantu',
  milestone_reward: '+{n} SP',

  reviews_panel_title: 'ULASAN PENGUNJUNG',
  reviews_panel_avg: 'Rating rata-rata',
  reviews_panel_empty: 'Belum ada ulasan',

  // --- Missing keys (English fallback) ---
  ghost_mummy: 'Mummy',
  ghost_werewolf: 'Werewolf',
  ghost_origin_egypt: 'Egypt',
  ghost_origin_europe: 'Europe',
  ghost_mummy_skill: 'Bandage Wrap: Entangles visitors, physical + visual scare',
  ghost_werewolf_skill: 'Full Moon Howl: Terrifying transformation, max physical + auditory',
  ghost_mummy_quote: 'These bandages are so itchy...',
  ghost_werewolf_quote: 'Is there a full moon tonight? I feel... different.',
  ghost_mummy_fatigued: 'My bandages came undone... I tripped...',
  ghost_werewolf_fatigued: 'Even wolves need sleep... woof... zzz...',
  tq_mummy_scream: 'Mummy practicing muffled screams through bandages...',
  tq_werewolf_scream: 'Werewolf howling at a picture of the moon...',
  tq_mummy_jumpscare: 'Mummy bursting out of sarcophagus repeatedly...',
  tq_werewolf_jumpscare: 'Werewolf practicing surprise transformations...',
  tq_mummy_psych: 'Mummy reading ancient curse scrolls for inspiration...',
  tq_werewolf_psych: 'Werewolf studying pack hunting psychology...',
  tq_mummy_atmo: 'Mummy arranging ancient Egyptian artifacts for ambiance...',
  tq_werewolf_atmo: 'Werewolf setting up moonlight projectors...',
  tq_mummy_physical: 'Mummy doing stretches to prevent bandage tangles...',
  tq_werewolf_physical: 'Werewolf doing 500 push-ups in wolf form...',
  tq_mummy_audience: 'Mummy researching which civilization visitors fear most...',
  tq_werewolf_audience: 'Werewolf tracking which visitors have dog allergies...',

  view_building: 'Gedung',
  view_other_buildings: '< Gedung Lain',
  view_lobby: 'Lobi',
  view_facilities: 'Fasilitas',
  view_academy: 'Akademi',
  lobby_title: 'Lobi',
  lobby_queue: 'Antrean',
  lobby_queue_empty: 'Tidak ada pengunjung menunggu',
  lobby_active_teams: 'Menjelajah: {cur}/{max} tim',
  lobby_wait_time: 'Tunggu: {n} detik',
  lobby_team_size: '{n} pengunjung',
  lobby_staff: 'Staf lobi',
  lobby_staff_empty: 'Belum ada staf',
  lobby_assign_staff: 'Tugaskan staf',
  lobby_unassign_staff: 'Cabut',
  lobby_staff_effect: 'Kurangi waktu tunggu, tingkatkan kepuasan',
  lobby_ticket_booth: 'Loket tiket',
  facilities_view_title: 'Manajemen fasilitas',
  facilities_view_empty: 'Belum ada fasilitas. Bangun di Menu!',
  facility_staff: 'Staf',
  facility_staff_none: 'Tanpa staf',
  facility_assign_staff: 'Tugaskan staf',
  facility_unassign_staff: 'Cabut staf',
  facility_staff_bonus: 'Staf meningkatkan kualitas layanan',
  facility_restroom: 'Toilet',
  facility_restroom_desc: 'Mencegah penalti kepuasan',
  facility_restroom_bonus: 'Tanpa penalti saat dibangun',
  facility_parking_lot: 'Tempat parkir',
  facility_parking_lot_desc: 'Meningkatkan tingkat kedatangan pengunjung',
  facility_parking_lot_bonus: '+{pct}% tingkat pengunjung per level',
  facility_first_aid: 'Pos P3K',
  facility_first_aid_desc: 'Merawat pengunjung yang kabur/pingsan',
  facility_first_aid_bonus: 'Mencegah ulasan buruk dari pengunjung kabur',
  facility_arcade: 'Arcade',
  facility_arcade_desc: 'Mini-game & atraksi horor',
  facility_arcade_bonus: 'Meningkatkan kegembiraan pengunjung',
  facility_fortune_teller: 'Peramal',
  facility_fortune_teller_desc: 'Tarot & pembacaan tangan misterius',
  facility_fortune_teller_bonus: 'Meningkatkan kepuasan pengunjung',
  facility_escape_room: 'Ruang Pelarian',
  facility_escape_room_desc: 'Tantangan puzzle horor berwaktu',
  facility_escape_room_bonus: 'Pendapatan tinggi per pengunjung',
  facility_stage: 'Panggung',
  facility_stage_desc: 'Pertunjukan & show hantu',
  facility_stage_bonus: 'Meningkatkan ketenaran taman',
  facility_voodoo_shop: 'Toko Voodoo',
  facility_voodoo_shop_desc: 'Jimat kutukan dan barang ajaib',
  facility_voodoo_shop_bonus: 'Meningkatkan drop item spesial',
  facility_ghost_cafe: 'Kafe Hantu',
  facility_ghost_cafe_desc: 'Minuman misterius buatan hantu',
  facility_ghost_cafe_bonus: 'Pengunjung tinggal lebih lama',
  facility_phantom_cinema: 'Bioskop Hantu',
  facility_phantom_cinema_desc: 'Pemutaran film horor supranatural',
  facility_phantom_cinema_bonus: 'Pendapatan tiket tinggi',
  facility_skeleton_spa: 'Spa Tengkorak',
  facility_skeleton_spa_desc: 'Relaksasi sampai ke tulang',
  facility_skeleton_spa_bonus: 'Pemulihan kelelahan lebih cepat',
  academy_title: 'Akademi Hantu',
  academy_empty: 'Rekrut hantu dulu sebelum latihan!',
  academy_select_ghost: 'Pilih hantu untuk dilatih',
  academy_select_training: 'Pilih kursus pelatihan',
  academy_skill_level: 'Lv.{n}/{max}',
  academy_skill_maxed: 'MAHIR',
  academy_training_time: '{sec} detik',
  academy_training_cost: '{sp} SP',
  academy_in_progress: 'Berlatih...',
  academy_complete: 'Selesai!',
  academy_skip_ad: 'Lewati (Iklan)',
  academy_ghost_busy: 'Hantu sedang sibuk',
  academy_acting: 'Kelas akting',
  academy_acting_desc: 'Tingkatkan akting dan timing menakuti',
  academy_acting_effect: 'Efek takut +20% per level',
  academy_human_relations: 'Hubungan manusia',
  academy_human_relations_desc: 'Belajar memahami pengunjung',
  academy_human_relations_effect: 'Kepuasan +15% per level',
  academy_psychology: 'Psikologi',
  academy_psychology_desc: 'Targetkan kelemahan pengunjung',
  academy_psychology_effect: 'Bonus kelemahan per level',
  academy_special_fx: 'Efek khusus',
  academy_special_fx_desc: 'Kuasai penggunaan properti dan efek',
  academy_special_fx_effect: 'Bonus properti x2 per level',
  academy_fitness: 'Latihan fisik',
  academy_fitness_desc: 'Tingkatkan stamina dan daya tahan',
  academy_fitness_effect: 'Pemulihan kelelahan +50% per level',
  academy_teamwork: 'Kerja tim',
  academy_teamwork_desc: 'Koordinasi dengan hantu terdekat',
  academy_teamwork_effect: 'Takut berantai +30% per level',
  academy_customer_service: 'Layanan pelanggan',
  academy_customer_service_desc: 'Tingkatkan layanan lobi/fasilitas',
  academy_customer_service_effect: 'Peningkatan kualitas layanan per level',
  facility_detail_income: 'Pendapatan',
  facility_detail_sp_per_group: '{n} SP / grup',
  facility_detail_bonus: 'Bonus',
  facility_detail_upgrade: 'Tingkatkan ({sp} SP)',
  facility_detail_assign: 'Tugaskan staf',
  facility_detail_status_active: 'Beroperasi',
  facility_detail_status_buildable: 'Tersedia',
  facility_detail_status_locked: 'Terkunci',
  facility_detail_no_income: 'Tanpa pendapatan langsung',
  ghost_role_scare: 'Tugas menakuti',
  ghost_role_lobby_staff: 'Staf lobi',
  ghost_role_facility_staff: 'Staf fasilitas',
  ghost_role_instructor: 'Instruktur',
  shop_pro_ghosts: 'Professional Ghosts',
  pro_ghost_badge: 'PRO',
  ghost_grim_reaper: 'Grim Reaper',
  ghost_origin_underworld: 'Underworld',
  ghost_grim_reaper_skill: 'Soul Harvest: All fear types S-rank, absolute terror',
  ghost_grim_reaper_quote: 'Your time has come... just kidding. Or am I?',
  ghost_grim_reaper_fatigued: 'Even death needs a vacation sometimes...',
  ghost_grim_reaper_unique: 'Instant max fear on any visitor type',
  ghost_blood_count: 'Blood Count',
  ghost_origin_transylvania: 'Transylvania',
  ghost_blood_count_skill: 'Blood Charm: Charisma-based visual + psychological S-rank',
  ghost_blood_count_quote: 'I do not drink... wine.',
  ghost_blood_count_fatigued: 'The sun... it burns... need coffin...',
  ghost_blood_count_unique: 'Charm aura: adjacent rooms get +20% scare',
  ghost_well_spirit: 'Well Spirit',
  ghost_well_spirit_skill: 'Well Crawl: Psychological horror S-rank, lingering dread',
  ghost_well_spirit_quote: '...seven days...',
  ghost_well_spirit_fatigued: 'My hair is so tangled... need conditioner...',
  ghost_well_spirit_unique: 'Lingering fear: visitors stay scared in next room',
  ghost_nightmare_specter: 'Nightmare Specter',
  ghost_origin_dreamworld: 'Dream World',
  ghost_nightmare_specter_skill: 'Nightmare Slash: Physical + psychological S-rank dream terror',
  ghost_nightmare_specter_quote: 'Sweet dreams... or not.',
  ghost_nightmare_specter_fatigued: 'Even nightmares need beauty sleep...',
  ghost_nightmare_specter_unique: 'Dream invasion: double scare on sleeping visitors',
  ghost_shadow_stalker: 'Shadow Stalker',
  ghost_origin_void: 'The Void',
  ghost_shadow_stalker_skill: 'Static Presence: Psychological horror max, stalker-type',
  ghost_shadow_stalker_quote: '...',
  ghost_shadow_stalker_fatigued: '......',
  ghost_shadow_stalker_unique: 'Static aura: all visitors on floor get +15% fear',

  // === Visitor Reactions ===
  reaction_angry: '#!',
  reaction_excited: '*',

  lobby_room_ticket_booth: 'Loket Tiket',
  lobby_room_ticket_booth_desc: 'Tempat pengunjung membeli tiket',
  lobby_room_ticket_booth_effect: 'Kecepatan pemrosesan tiket dasar',
  lobby_room_waiting_lounge: 'Ruang Tunggu',
  lobby_room_waiting_lounge_desc: 'Area tunggu nyaman dengan tempat duduk',
  lobby_room_waiting_lounge_effect: '+20% kesabaran pengunjung per level',
  lobby_room_vip_lounge: 'Lounge VIP',
  lobby_room_vip_lounge_desc: 'Ruang tunggu premium untuk pengunjung VIP',
  lobby_room_vip_lounge_effect: 'Pengunjung VIP menghabiskan 2x SP',
  lobby_room_reservation_center: 'Pusat Reservasi',
  lobby_room_reservation_center_desc: 'Sistem reservasi untuk pengunjung',
  lobby_room_reservation_center_effect: '+15% tingkat kedatangan pengunjung per level',

  lobby_build_floor: '+ {name} ({sp} SP)',
  lobby_build_select: 'Pilih fasilitas...',
  lobby_add_floor: '+ {sp} SP',
  lobby_empty_floor: 'Bangun Fasilitas',
  lobby_select_facility: 'Pilih Fasilitas',
  lobby_props_count: '{n} properti',
  lobby_props_title: 'Objek',
  lobby_tab_info: 'Info',
  lobby_tab_objects: 'Objek',
  lobby_tab_upgrade: 'Upgrade',
  lobby_tab_demolish: 'Bongkar',
  lobby_demolish_confirm: 'Hapus fasilitas ini? Lantai tetap ada, menjadi lantai kosong.',
  lobby_demolish_btn: 'Bongkar Fasilitas',
  lobby_no_ghost: 'Tidak ada staf',
  lobby_upgrade_max: 'Level Maks',
  lobby_upgrade_next: 'Lv.{from} -> Lv.{to}',
  lobby_upgrade_effect: 'Efek setelah upgrade:',
  facility_build_floor: 'Bangun',

  facility_map_title: 'Area Fasilitas',
  facility_build_here: 'Bangun',
  facility_select_to_build: 'Pilih Fasilitas',
  facility_all_built: 'Semua fasilitas sudah dibangun.',
  facility_unlock_plot: '{sp} SP',
  facility_unlock_plot_title: 'Buka Plot',
  facility_unlock_plot_desc: 'Buka plot ini dengan {sp} SP untuk membangun fasilitas baru.',
  facility_unlock_plot_btn: 'Buka ({sp} SP)',
  facility_build_popup_title: 'Bangun Fasilitas',
  facility_build_action: 'Bangun',
  facility_select_theme: 'Pilih Tema',
  facility_upgrade_preview: 'Efek Upgrade',
  facility_upgrade_revenue: 'Pendapatan per grup',
  facility_upgrade_bonus: 'Bonus Pendapatan',
  facility_upgrade_capacity: 'Kapasitas',
  facility_upgrade_current: 'Saat ini',
  facility_upgrade_next: 'Berikutnya',
  facility_upgrade_max_level: 'Level Maksimum Tercapai',
  facility_revenue: 'Pendapatan',
  facility_total_revenue: 'Total Pendapatan',
  facility_hourly_revenue: 'Per Grup',
  facility_set_price: 'Atur Harga',
  facility_price_hint_high: 'Harga tinggi: untung lebih, pengunjung kurang',
  facility_price_hint_low: 'Harga rendah: pengunjung lebih, untung kurang',
  facility_price_hint_free: 'Gratis masuk',
  facility_price_hint_normal: 'Harga seimbang',
  facility_open: 'Buka',
  facility_close: 'Tutup',
  facility_closed_badge: 'TUTUP',
  facility_needs_staff: 'Tugaskan staf untuk membuka',
  facility_demolish: 'Bongkar',
  facility_demolish_confirm: 'Bongkar {name}? Tidak bisa dibatalkan.',
  facility_move: 'Pindah',
  facility_move_select: 'Pilih plot kosong untuk dipindahkan',
  facility_move_no_empty: 'Tidak ada plot kosong.',

  lobby_prop_sofa: 'Sofa',
  lobby_prop_sofa_desc: 'Tempat duduk nyaman untuk pengunjung',
  lobby_prop_tv_screen: 'Layar TV',
  lobby_prop_tv_screen_desc: 'Hiburan selama menunggu',
  lobby_prop_vending_machine: 'Mesin Penjual',
  lobby_prop_vending_machine_desc: 'Camilan dan minuman untuk pengunjung',
  lobby_prop_info_sign: 'Papan Info',
  lobby_prop_info_sign_desc: 'Memandu pengunjung ke tempat yang tepat',
  lobby_prop_potted_plant: 'Tanaman Pot',
  lobby_prop_potted_plant_desc: 'Sentuhan hijau yang menyeramkan',
  lobby_prop_umbrella_stand: 'Tempat Payung',
  lobby_prop_umbrella_stand_desc: 'Tempat payung basah',

  fac_prop_display_shelf: 'Rak Display',
  fac_prop_display_shelf_desc: 'Menampilkan produk secara menarik',
  fac_prop_cash_register: 'Mesin Kasir',
  fac_prop_cash_register_desc: 'Mempercepat transaksi',
  fac_prop_coffee_machine: 'Mesin Kopi',
  fac_prop_coffee_machine_desc: 'Menyajikan minuman panas',
  fac_prop_menu_board: 'Papan Menu',
  fac_prop_menu_board_desc: 'Menampilkan pilihan makanan',
  fac_prop_camera_light: 'Lampu Kamera',
  fac_prop_camera_light_desc: 'Pencahayaan foto lebih baik',
  fac_prop_backdrop: 'Latar Belakang',
  fac_prop_backdrop_desc: 'Latar foto bertema',
  fac_prop_hand_dryer: 'Pengering Tangan',
  fac_prop_hand_dryer_desc: 'Menjaga kebersihan dan kekeringan',
  fac_prop_mirror: 'Cermin',
  fac_prop_mirror_desc: 'Perlengkapan kamar mandi menyeramkan',
  fac_prop_parking_sign: 'Papan Parkir',
  fac_prop_parking_sign_desc: 'Mengarahkan pengunjung ke parkir',
  fac_prop_barrier_gate: 'Palang Pintu',
  fac_prop_barrier_gate_desc: 'Kontrol parkir otomatis',
  fac_prop_first_aid_kit: 'Kotak P3K',
  fac_prop_first_aid_kit_desc: 'Perlengkapan medis dasar',
  fac_prop_stretcher: 'Tandu',
  fac_prop_stretcher_desc: 'Untuk pengunjung yang pingsan karena takut',

  tab_facilities: 'Fasilitas',
  tab_hire: 'Rekrut',
  tab_staff: 'Staf',
  tab_support_facilities: 'Fasilitas',
  tab_achievements: 'Pencapaian',
  achievements_title: 'Pencapaian',
  achievements_coming_soon: 'Segera hadir...',
  facilities_mgmt_title: 'Manajemen Fasilitas',
  facility_condition: 'Kondisi',
  facility_hygiene: 'Kebersihan',
  facility_condition_warning: 'Perlu perbaikan!',
  facility_hygiene_warning: 'Perlu pembersihan!',
  dispatch_repair: 'Kirim teknisi',
  dispatch_clean: 'Kirim petugas kebersihan',
  no_repair_staff: 'Tidak ada teknisi',
  no_janitor_staff: 'Tidak ada petugas kebersihan',
  repair_dispatched: 'Teknisi dikirim',
  clean_dispatched: 'Petugas kebersihan dikirim',
  ticket_section_title: 'Harga Tiket',
  expected_visitors: 'Perkiraan pengunjung: ~{n}/hari',
  star_rating_title: 'Penilaian Pengunjung',
  star_level_gray: 'Bintang Abu-abu',
  star_level_bronze: 'Bintang Perunggu',
  star_level_silver: 'Bintang Perak',
  star_level_gold: 'Bintang Emas',
  star_level_rainbow: 'Bintang Pelangi',
  star_evolution_max: 'Rumah Hantu Terbaik',
  star_current: '{cur}/{max}',
  hire_title: 'Rekrut Staf',
  hire_scare_section: 'Spesialis Menakuti',
  hire_staff_section: 'Staf Fasilitas',
  staff_role_repair: 'Teknisi',
  staff_role_janitor: 'Petugas Kebersihan',
  staff_role_ticket: 'Penjual Tiket',
  staff_role_guide: 'Pemandu',
  staff_role_repair_desc: 'Memperbaiki kerusakan',
  staff_role_janitor_desc: 'Menjaga kebersihan',
  staff_role_ticket_desc: 'Mengoperasikan lobi',
  staff_role_guide_desc: 'Bonus kepuasan pengunjung',
  hire_cost_label: '{sp} SP',
  staff_title: 'Daftar Staf',
  staff_empty: 'Belum ada staf yang direkrut.',
  staff_detail_title: 'Detail Staf',
  staff_detail_type: 'Jenis',
  staff_detail_role: 'Peran',
  staff_detail_grade: 'Nilai',
  staff_detail_skills: 'Keterampilan',
  staff_detail_assigned: 'Ditugaskan di',
  staff_detail_not_assigned: 'Belum ditugaskan',
  staff_detail_hired_days: 'Direkrut: Hari {n}',
  staff_detail_praise: 'Pujian: {n}',
  skill_acting: 'Akting',
  skill_friendliness: 'Keramahan',
  skill_psychology: 'Psikologi',
  skill_special_fx: 'Efek Khusus',
  skill_fitness: 'Kebugaran',
  skill_teamwork: 'Kerja Tim',
  skill_service: 'Layanan',
  room_detail_tab_info: 'Info',
  room_detail_tab_props: 'Fasilitas',
  room_detail_tab_upgrade: 'Upgrade',
  room_detail_tab_demolish: 'Hancurkan',
  room_detail_ghost_none: 'Belum ditugaskan',
  room_detail_condition: 'Kondisi',
  room_detail_hygiene: 'Kebersihan',
  room_detail_request_repair: 'Minta Perbaikan ({sp} SP)',
  room_detail_request_cleaning: 'Minta Pembersihan ({sp} SP)',
  room_detail_repairing: 'Memperbaiki... {sec}d',
  room_detail_cleaning: 'Membersihkan... {sec}d',
  room_detail_collapsed: 'RUNTUH',
  room_detail_collapsed_desc: 'Ruangan telah runtuh. Perbaiki untuk memulihkan.',
  room_detail_condition_ok: 'Kondisi baik',
  room_detail_hygiene_ok: 'Kebersihan baik',
  room_upgrade_structure: 'Penguatan Struktur',
  room_upgrade_structure_desc: 'Kurangi penurunan kondisi per kunjungan',
  room_upgrade_structure_effect: '-{pct}% penurunan kondisi per level',
  room_upgrade_structure_bonus_10: 'Ruangan Kokoh: Biaya perbaikan -30%',
  room_upgrade_structure_bonus_20: 'Ruangan Abadi: Kondisi minimal 50',
  room_upgrade_purify: 'Pemurnian Otomatis',
  room_upgrade_purify_desc: 'Kurangi penurunan kebersihan per kunjungan',
  room_upgrade_purify_effect: '-{pct}% penurunan kebersihan per level',
  room_upgrade_purify_bonus_10: 'Ruangan Wangi: Kepuasan +10%',
  room_upgrade_purify_bonus_20: 'Sihir Pembersih: Kebersihan pulih otomatis',
  room_upgrade_level: 'Lv.{cur}/{max}',
  room_upgrade_cost: 'Upgrade ({sp} SP)',
  room_upgrade_max: 'MAKS',
  room_upgrade_bonus_unlocked: 'Terbuka!',
  room_upgrade_bonus_locked: 'Bonus Lv.{n}',
  room_demolish_warning: 'Menghancurkan ruangan ini akan menghapus semua fasilitas dan upgrade.',
  room_demolish_cost: 'Biaya: Gratis',
  room_demolish_btn: 'Hancurkan',
  room_demolish_confirm: 'Yakin ingin menghancurkan ruangan ini? Tidak bisa dibatalkan.',
  room_props_installed: 'Properti Terpasang',
  room_props_available: 'Properti Tersedia',
  room_props_none: 'Tidak ada properti',
  menu_bgm: 'BGM',
  menu_sfx: 'SFX',
  menu_language: 'Bahasa',
  menu_reset: 'Reset Game',
  menu_reset_confirm: 'Yakin? Tidak bisa dibatalkan.',
  menu_info: 'Info Game',
  menu_version: 'Versi {v}',
  menu_on: 'ON',
  menu_off: 'OFF',

  // === Room Emotion Stats ===
  stat_fear: 'Ketakutan',
  stat_thrill: 'Sensasi',
  stat_atmosphere: 'Suasana',
  stat_fun: 'Kesenangan',
  stat_total: 'Statistik',
  room_grade: 'Nilai',
  grade_S: 'S',
  grade_A: 'A',
  grade_B: 'B',
  grade_C: 'C',
  grade_D: 'D',
  grade_F: 'F',

  phase_day: 'Persiapan',
  phase_evening: 'Buka',
  phase_night: 'Tutup',
  phase_day_icon: '\u2600',
  phase_evening_icon: '\uD83C\uDF19',
  phase_night_icon: '\u2B50',
  phase_remaining: '{sec}d',
  phase_day_hint: 'Siapkan rumah hantu! Perbaiki, tempatkan hantu, tingkatkan.',
  phase_evening_hint: 'Jam buka! Pengunjung datang.',
  open_now_btn: 'BUKA SEKARANG',
  speed_btn: 'x{n}',
  day_auto_open_hint: 'Sudah sore! Saatnya buka.',
  evening_ending_hint: 'Waktu tutup! Membereskan...',
  floor1_blocked_warning: 'Masuk diblokir! Perbaiki Lantai 1!',
  gstaff_title: 'Staf Hantu',
  gstaff_repairman: 'Hantu Reparasi',
  gstaff_repairman_desc: 'Hantu yang menembus dinding untuk memperbaiki ruangan',
  gstaff_repairman_effect: 'Perbaiki ruangan dengan kondisi terburuk',
  gstaff_janitor: 'Hantu Pembersih',
  gstaff_janitor_desc: 'Membersihkan ruangan dengan energi spektral',
  gstaff_janitor_effect: 'Bersihkan ruangan dengan kebersihan terendah',
  gstaff_promoter: 'Hantu Promotor',
  gstaff_promoter_desc: 'Menarik pengunjung dengan bisikan menyeramkan',
  gstaff_promoter_effect: '+20% pengunjung per level',
  gstaff_medic: 'Hantu Penyembuh',
  gstaff_medic_desc: 'Menenangkan pengunjung ketakutan dengan pesona hantu',
  gstaff_medic_effect: 'Pengunjung kabur beri ulasan netral',
  gstaff_security: 'Hantu Penjaga',
  gstaff_security_desc: 'Menjaga ketertiban dengan kehadiran mengintimidasi',
  gstaff_security_effect: '+10% kepuasan per level',
  gstaff_hire_cost: 'Panggil: {sp} SP',
  gstaff_salary: 'Pemeliharaan: {sp} SP/hari',
  gstaff_fire: 'Usir',
  gstaff_fire_confirm: 'Usir hantu staf ini?',
  gstaff_level: 'Lv.{n}',
  gstaff_none: 'Belum ada hantu staf dipanggil.',
  day_summary_salaries: 'Gaji Staf',
  day_summary_net_earnings: 'Pendapatan Bersih',
  day_summary_street_visitors: 'Pengunjung Jalanan',
  day_summary_street_revenue: 'Pendapatan Jalanan',
  day_summary_reviews_title: 'ULASAN PENGUNJUNG',
  day_summary_avg_stars: 'RATING RATA-RATA',
  day_summary_fame_change: 'KETENARAN',
  day_summary_no_reviews: 'Belum ada ulasan hari ini',
  day_summary_review_visitor: 'Pengunjung #{n}',
  day_summary_highlight: 'SOROTAN',

  // === Tutorial ===
  tutorial_welcome_title: 'Selamat Datang di Rumah Hantu!',
  tutorial_welcome_body: 'Mulai hari ini kamu adalah pemilik rumah hantu ini. Ayo buat rumah hantu paling seru bersama hantu-hantumu!',
  tutorial_welcome_btn: 'Mulai!',
  tutorial_build_title: 'Bangun Ruangan',
  tutorial_build_body: 'Pertama, ayo bangun ruangan. Ketuk tombol "+" untuk memilih tipe ruangan.',
  tutorial_ghost_title: 'Tempatkan Hantu',
  tutorial_ghost_body: 'Tempatkan hantu di ruangan untuk menakuti pengunjung. Ketuk ruangan untuk menempatkan hantu.',
  tutorial_open_title: 'Buka Rumah Hantu',
  tutorial_open_body: 'Sudah siap! Ketuk tombol "Buka" di bawah untuk menerima pengunjung.',
  tutorial_facility_intro_title: 'Area Fasilitas',
  tutorial_facility_intro_body: 'Tamanmu punya lahan fasilitas! Bangun toko dan atraksi untuk penghasilan lebih.',
  tutorial_facility_build_title: 'Bangun Fasilitas',
  tutorial_facility_build_body: 'Ketuk lahan kosong dan pilih fasilitas. Coba Toko Suvenir atau Snack Bar!',
  tutorial_facility_staff_title: 'Tugaskan Staf',
  tutorial_facility_staff_body: 'Tugaskan hantu ke fasilitas baru. Staf meningkatkan pendapatan 20%!',
  tutorial_facility_open_title: 'Buka Fasilitas',
  tutorial_facility_open_body: 'Buka fasilitas agar pengunjung bisa menggunakannya. Kamu juga bisa atur harga!',
  tutorial_done_title: 'Tutorial Selesai!',
  tutorial_done_body: 'Hebat! Kamu sudah menguasai dasar-dasarnya. Terus perluas rumah hantumu!',
  tutorial_skip: 'Lewati',
  tutorial_next: 'Lanjut',
  tutorial_got_it: 'Mengerti!',

  // === Story Arc System ===
  story_intro: 'Intro',
  story_rising: 'Naik',
  story_climax: 'Klimaks',
  story_resolution: 'Penyelesaian',
  story_grade: 'Alur: {grade} (+{bonus}% SP)',
  story_bonus: '+{bonus}% SP',
  story_guide_title: 'Sistem Alur Cerita Terbuka!',
  story_guide_desc: 'Dengan 4+ ruangan, atur lantai untuk membuat alur cerita dan dapatkan SP bonus!',
  story_role_label: '{role}',
  story_intro_desc: 'Bangun suasana: atmosfer tinggi, ketakutan rendah',
  story_rising_desc: 'Tingkatkan ketegangan: naikkan ketakutan dan sensasi',
  story_climax_desc: 'Teror puncak: ketakutan dan sensasi maksimal',
  story_resolution_desc: 'Pelepasan dan kesenangan: tingkatkan kesenangan',
  story_room_role: 'Peran cerita: {role}',
  story_none: 'Tidak ada',

  // === Room Available Props ===
  room_available_props: 'Dapat dipasang: {props}',

  // === Lobby Queue System ===
  lq_waiting_count: 'Antrean: {n}/{max}',
  lq_avg_patience: 'Rata-rata kesabaran: {n}%',
  lq_queue_empty: 'Tidak ada pengunjung dalam antrean',

  // === Lobby Facilities ===
  lf_title: 'Fasilitas Lobi',
  lf_patience_bonus: 'Kesabaran -{n}%',
  lf_revenue_bonus: '+{n} SP/pengunjung',
  lf_npc_bonus: 'NPC: +15% kesabaran, +20% pendapatan',
  lf_npc_staff: 'Staf NPC',

  lf_ticket_booth: 'Loket Tiket',
  lf_ticket_booth_desc: 'Konter penjualan tiket yang diperlukan',
  lf_waiting_lounge: 'Ruang Tunggu',
  lf_waiting_lounge_desc: 'Area tunggu nyaman dengan kursi (+kesabaran)',
  lf_vip_lounge: 'Lounge VIP',
  lf_vip_lounge_desc: 'Ruang tunggu premium untuk pengunjung VIP',
  lf_reservation_center: 'Pusat Reservasi',
  lf_reservation_center_desc: 'Sistem reservasi pengunjung (+kesabaran)',
  lf_poster_wall: 'Dinding Poster',
  lf_poster_wall_desc: 'Poster menyeramkan meningkatkan antisipasi (+kesabaran)',
  lf_snack_cart: 'Gerobak Makanan',
  lf_snack_cart_desc: 'Makanan ringan menjaga kesabaran pengunjung',
  lf_souvenir_booth: 'Kios Suvenir',
  lf_souvenir_booth_desc: 'Jual suvenir untuk pendapatan tambahan',
  lf_photo_zone: 'Zona Foto',
  lf_photo_zone_desc: 'Pengunjung berfoto, meningkatkan reputasi dan pendapatan',
  lf_tv_monitor: 'Monitor TV',
  lf_tv_monitor_desc: 'Video highlight teror menghibur pengunjung',
  lf_costume_rental: 'Sewa Kostum',
  lf_costume_rental_desc: 'Pengunjung menyewa kostum untuk kesenangan dan pendapatan ekstra',
  lf_fortune_booth: 'Stan Ramalan',
  lf_fortune_booth_desc: 'Ramalan misterius menciptakan suasana horor',
  lf_built_badge: 'Terbangun',

  // === Lobby Facility Unique Effects ===
  lf_ue_ticket_speed: 'Kecepatan Tiket: interval masuk -15% per level',
  lf_ue_max_queue_up: 'Kapasitas: maks antrian +5 per level',
  lf_ue_vip_rate_up: 'Tingkat VIP: kemunculan VIP x2 per level',
  lf_ue_satisfaction_up: 'Antisipasi: kepuasan dasar +20%',
  lf_ue_emergency_patience: 'Camilan Darurat: +15 kesabaran untuk pengunjung rendah',
  lf_ue_revisit_rate_up: 'Suvenir: bonus pengunjung hari berikutnya +15%',
  lf_ue_reputation_per_day: 'Berbagi SNS: reputasi harian +2 per level',
  lf_ue_anticipation_up: 'Preview Horor: peningkatan antisipasi +40%',
  lf_ue_fun_bonus: 'Kostum: stat kesenangan +15 per level',
  lf_ue_random_sp_bonus: 'Ramalan: peluang bonus SP acak +10%',
  ticket_price_setting: 'Harga Tiket',

  // === Lobby Facility Props ===
  lobby_prop_candle: 'Lilin',
  lobby_prop_candle_desc: 'Lilin berkedip untuk suasana',
  lobby_prop_cobweb: 'Jaring Laba-laba',
  lobby_prop_cobweb_desc: 'Jaring laba-laba menyeramkan',
  lobby_prop_pumpkin: 'Labu',
  lobby_prop_pumpkin_desc: 'Lentera labu klasik',
  lobby_prop_magazine_rack: 'Rak Majalah',
  lobby_prop_magazine_rack_desc: 'Majalah horor untuk menunggu',
  lobby_prop_chandelier: 'Chandelier',
  lobby_prop_chandelier_desc: 'Chandelier gothic yang elegan',
  lobby_prop_wine_glass: 'Gelas Anggur',
  lobby_prop_wine_glass_desc: 'Gelas kristal untuk suasana VIP',
  lobby_prop_velvet_curtain: 'Tirai Beludru',
  lobby_prop_velvet_curtain_desc: 'Tirai beludru yang mewah',
  lobby_prop_gold_frame: 'Bingkai Emas',
  lobby_prop_gold_frame_desc: 'Bingkai foto emas yang mewah',
  lobby_prop_picture_frame: 'Bingkai Foto',
  lobby_prop_picture_frame_desc: 'Potret terkutuk di dinding',
  lobby_prop_spotlight: 'Lampu Sorot',
  lobby_prop_spotlight_desc: 'Pencahayaan dramatis untuk display',
  lobby_prop_skull_ornament: 'Ornamen Tengkorak',
  lobby_prop_skull_ornament_desc: 'Tengkorak dekoratif yang menyeramkan',
  lobby_prop_pumpkin_cookie: 'Kue Labu',
  lobby_prop_pumpkin_cookie_desc: 'Kue berbentuk labu yang lezat',
  lobby_prop_ghost_drink: 'Minuman Hantu',
  lobby_prop_ghost_drink_desc: 'Minuman bercahaya misterius',
  lobby_prop_napkin_holder: 'Tempat Tisu',
  lobby_prop_napkin_holder_desc: 'Menjaga area camilan tetap rapi',
  lobby_prop_display_shelf: 'Rak Display',
  lobby_prop_display_shelf_desc: 'Menampilkan suvenir dengan menarik',
  lobby_prop_plush_doll: 'Boneka',
  lobby_prop_plush_doll_desc: 'Boneka hantu yang lucu',
  lobby_prop_keychain_rack: 'Rak Gantungan Kunci',
  lobby_prop_keychain_rack_desc: 'Rak putar gantungan kunci menyeramkan',
  lobby_prop_wrapping_paper: 'Kertas Kado',
  lobby_prop_wrapping_paper_desc: 'Kertas kado bertema Halloween',
  lobby_prop_backdrop: 'Latar Belakang',
  lobby_prop_backdrop_desc: 'Latar foto bertema',
  lobby_prop_prop_box: 'Kotak Properti',
  lobby_prop_prop_box_desc: 'Kotak aksesoris foto yang seru',
  lobby_prop_mask_stand: 'Stan Topeng',
  lobby_prop_mask_stand_desc: 'Display topeng menyeramkan untuk foto',
  lobby_prop_antenna: 'Antena',
  lobby_prop_antenna_desc: 'Penerima sinyal TV',
  lobby_prop_remote_control: 'Remote',
  lobby_prop_remote_control_desc: 'Kontrol saluran TV',
  lobby_prop_speaker: 'Speaker',
  lobby_prop_speaker_desc: 'Surround sound untuk film horor',
  lobby_prop_cable_wires: 'Kabel',
  lobby_prop_cable_wires_desc: 'Kabel kusut menambah kesan menyeramkan',
  lobby_prop_clothes_rack: 'Rak Baju',
  lobby_prop_clothes_rack_desc: 'Rak berisi kostum menyeramkan',
  lobby_prop_mirror: 'Cermin',
  lobby_prop_mirror_desc: 'Cermin panjang untuk cek kostum',
  lobby_prop_makeup_table: 'Meja Rias',
  lobby_prop_makeup_table_desc: 'Tempat bermakeup menyeramkan',
  lobby_prop_wig_stand: 'Stan Wig',
  lobby_prop_wig_stand_desc: 'Koleksi wig menyeramkan',
  lobby_prop_crystal_ball: 'Bola Kristal',
  lobby_prop_crystal_ball_desc: 'Lihat masa depan menyeramkanmu',
  lobby_prop_tarot_cards: 'Kartu Tarot',
  lobby_prop_tarot_cards_desc: 'Kartu ramalan misterius',
  lobby_prop_curtain: 'Tirai',
  lobby_prop_curtain_desc: 'Tirai misterius untuk stan ramalan',
  lobby_prop_candelabra: 'Kandil',
  lobby_prop_candelabra_desc: 'Tempat lilin multi-lengan untuk suasana',

  lnpc_title: 'Lobby Ghost Patrol',
  lnpc_assign: 'Assign Ghost',
  lnpc_unassign: 'Remove',
  lnpc_desc: 'Ghosts scare waiting visitors, boosting patience',
  lnpc_slot: '{cur}/{max} Ghosts',
  evt_time_remaining: '{sec}s remaining',
  evt_rain_name: 'Sudden Rain',
  evt_rain_desc: 'Heavy rain falls suddenly. Visitors without umbrellas are leaving the queue.',
  evt_rain_c1: 'Ignore',
  evt_rain_c2: 'Hand out umbrellas (100 SP)',
  evt_rain_r1: '3 visitors left the queue in the rain.',
  evt_rain_r2: 'Umbrellas were handed out. Everyone stays dry.',
  evt_couple_fight_name: 'Couple Fight',
  evt_couple_fight_desc: 'A couple starts arguing loudly in the queue, disturbing others.',
  evt_couple_fight_c1: 'Handle it',
  evt_couple_fight_r1: 'The situation has been dealt with.',
  evt_crying_child_name: 'Crying Child',
  evt_crying_child_desc: 'A child starts crying in the queue, making others uneasy.',
  evt_crying_child_c1: 'Give candy (50 SP)',
  evt_crying_child_c2: 'Ignore',
  evt_crying_child_r1: 'The candy cheered the child up.',
  evt_crying_child_r2: 'The crying continued, testing everyone\'s patience.',
  evt_blackout_name: 'Power Outage',
  evt_blackout_desc: 'A sudden power outage plunges everything into darkness.',
  evt_blackout_c1: 'Start generator (200 SP)',
  evt_blackout_c2: 'Wait it out',
  evt_blackout_r1: 'The generator kicked in. Business continues.',
  evt_blackout_r2: 'Everyone waited in the dark for a while.',
  evt_line_cutter_name: 'Line Cutter',
  evt_line_cutter_desc: 'Someone brazenly cuts into the front of the queue.',
  evt_line_cutter_c1: 'Call security',
  evt_line_cutter_c2: 'Ignore',
  evt_line_cutter_r1: 'Security escorted the line cutter out.',
  evt_line_cutter_r2: 'Others in line grumble in frustration.',
  evt_fake_ghost_name: 'Fake Ghost Prank',
  evt_fake_ghost_desc: 'A visitor dressed as a ghost is scaring others in line. The crowd seems amused.',
  evt_fake_ghost_c1: 'Let them have fun',
  evt_fake_ghost_r1: 'The prank added to the spooky atmosphere. Reputation up!',
  evt_lost_item_name: 'Lost Item Report',
  evt_lost_item_desc: 'A visitor reports a lost item near the entrance.',
  evt_lost_item_c1: 'Help find it (Reputation +5)',
  evt_lost_item_c2: 'Ignore',
  evt_lost_item_r1: 'The lost item was found! The visitor is grateful.',
  evt_lost_item_r2: 'The visitor left disappointed.',
  evt_snack_sold_out_name: 'Snacks Sold Out',
  evt_snack_sold_out_desc: 'The snack cart ran out of stock. Visitors are asking for snacks.',
  evt_snack_sold_out_c1: 'Emergency restock (100 SP)',
  evt_snack_sold_out_c2: 'Wait for next shipment',
  evt_snack_sold_out_r1: 'Snacks are back in stock.',
  evt_snack_sold_out_r2: 'Visitors will have to wait.',
  evt_sns_selfie_name: 'SNS Photo Op',
  evt_sns_selfie_desc: 'A visitor wants to take a selfie for social media.',
  evt_sns_selfie_c1: 'Acknowledge',
  evt_sns_selfie_r1: 'The post boosted your online presence.',
  evt_hot_weather_name: 'Scorching Heat',
  evt_hot_weather_desc: 'The temperature soars. Visitors look uncomfortable in the heat.',
  evt_hot_weather_c1: 'Free drinks (150 SP)',
  evt_hot_weather_c2: 'Endure it',
  evt_hot_weather_r1: 'Cool drinks refreshed everyone.',
  evt_hot_weather_r2: 'The heat is taking a toll on patience.',
  evt_tour_bus_name: 'Tour Bus Arrival',
  evt_tour_bus_desc: 'A tour bus just arrived! A large group of tourists floods the entrance.',
  evt_tour_bus_c1: 'Welcome them',
  evt_tour_bus_r1: 'The queue fills up with excited tourists.',
  evt_tv_coverage_name: 'TV Crew Request',
  evt_tv_coverage_desc: 'A local TV station wants to cover your haunted house.',
  evt_tv_coverage_c1: 'Accept (risky)',
  evt_tv_coverage_c2: 'Decline',
  evt_tv_coverage_r1: 'The coverage aired. Results vary...',
  evt_tv_coverage_r2: 'You politely declined the offer.',
  evt_spy_name: 'Rival Spy',
  evt_spy_desc: 'You spot someone suspiciously taking notes about your operations.',
  evt_spy_c1: 'Apprehend (need security)',
  evt_spy_c2: 'Ignore',
  evt_spy_r1: 'The spy was caught. You recovered valuable intel.',
  evt_spy_r2: 'Some of your ideas might leak to competitors.',
  evt_health_inspection_name: 'Health Inspection',
  evt_health_inspection_desc: 'Health inspectors arrive for a surprise visit.',
  evt_health_inspection_c1: 'Open the doors',
  evt_health_inspection_r1: 'The inspection is complete.',
  evt_halloween_season_name: 'Halloween Fever',
  evt_halloween_season_desc: 'Halloween spirit fills the air! Everyone is in the mood for scares.',
  evt_halloween_season_c1: 'Celebrate!',
  evt_halloween_season_r1: 'Halloween boost! Extra visitors and SP incoming.',
  evt_ghost_strike_name: 'Ghost Strike',
  evt_ghost_strike_desc: 'Overworked ghosts are refusing to scare. They demand better conditions.',
  evt_ghost_strike_c1: 'Pay bonus (500 SP)',
  evt_ghost_strike_c2: 'Wait it out',
  evt_ghost_strike_r1: 'The bonus satisfied the ghosts. Back to work!',
  evt_ghost_strike_r2: 'The strike continues for a while...',
  evt_mystery_visitor_name: 'Mystery Critic',
  evt_mystery_visitor_desc: 'A famous horror critic is visiting in disguise. Results depend on your reputation.',
  evt_mystery_visitor_c1: 'Best behavior',
  evt_mystery_visitor_r1: 'The critic revealed themselves and wrote a review.',
  evt_maintenance_accident_name: 'Equipment Malfunction',
  evt_maintenance_accident_desc: 'A piece of equipment malfunctioned in one of the rooms!',
  evt_maintenance_accident_c1: 'Assess damage',
  evt_maintenance_accident_r1: 'A room sustained damage. Repairs needed.',
  evt_sns_viral_name: 'Viral Video',
  evt_sns_viral_desc: 'A visitor\'s video of your haunted house went viral online!',
  evt_sns_viral_c1: 'Ride the wave',
  evt_sns_viral_r1: 'Your fame skyrockets! Reputation and SP boosted.',
  evt_total_blackout_name: 'Total Blackout',
  evt_total_blackout_desc: 'All power goes out across the entire area. Complete darkness.',
  evt_total_blackout_c1: 'Candlelight event (+Rep)',
  evt_total_blackout_c2: 'Wait for power',
  evt_total_blackout_r1: 'The candlelight atmosphere was a hit!',
  evt_total_blackout_r2: 'Everyone waited in the dark.',
  evt_famous_youtuber_name: 'Famous Streamer',
  evt_famous_youtuber_desc: 'A famous horror streamer with millions of followers is live-streaming from your haunted house!',
  evt_famous_youtuber_c1: 'Give VIP treatment',
  evt_famous_youtuber_r1: 'The stream was a massive hit! Reputation +30, SP +2000.',
  evt_celeb_visit_name: 'Celebrity Visit',
  evt_celeb_visit_desc: 'A major celebrity has arrived for a private scare session!',
  evt_celeb_visit_c1: 'Roll out the red carpet',
  evt_celeb_visit_r1: 'The celebrity loved it! Huge publicity boost.',
  evt_franchise_offer_name: 'Franchise Offer',
  evt_franchise_offer_desc: 'A corporation wants to franchise your haunted house brand.',
  evt_franchise_offer_c1: 'Accept (10000 SP)',
  evt_franchise_offer_c2: 'Decline',
  evt_franchise_offer_r1: 'Deal signed! A hefty payment arrives.',
  evt_franchise_offer_r2: 'You prefer to stay independent.',
  evt_intl_contest_name: 'International Horror Contest',
  evt_intl_contest_desc: 'Your haunted house is invited to an international scare competition!',
  evt_intl_contest_c1: 'Enter the contest',
  evt_intl_contest_r1: 'You earned recognition on the world stage!',
  evt_documentary_name: 'Documentary Filming',
  evt_documentary_desc: 'A documentary crew wants to film the story of your haunted house.',
  evt_documentary_c1: 'Allow filming',
  evt_documentary_r1: 'The documentary premieres to rave reviews!',
  evt_ghost_king_name: 'The Ghost King Appears',
  evt_ghost_king_desc: 'A legendary ghost is drawn to your haunted house by its fame.',
  evt_ghost_king_c1: 'Welcome the Ghost King',
  evt_ghost_king_r1: 'The Ghost King joins your ranks! Morale soars.',
  evt_gov_subsidy_name: 'Government Grant',
  evt_gov_subsidy_desc: 'The tourism board awards your haunted house a cultural preservation grant.',
  evt_gov_subsidy_c1: 'Accept the grant',
  evt_gov_subsidy_r1: 'Grant received: 5000 SP!',
  evt_vip_party_name: 'VIP Party Request',
  evt_vip_party_desc: 'A wealthy patron wants to rent the entire haunted house for a private party.',
  evt_vip_party_c1: 'Accept (8000 SP)',
  evt_vip_party_c2: 'Decline',
  evt_vip_party_r1: 'The VIP party was a huge success!',
  evt_vip_party_r2: 'You keep the doors open for regular visitors.',
  evt_horror_festival_name: 'Horror Festival',
  evt_horror_festival_desc: 'The city is hosting a horror festival and your haunted house is the main attraction!',
  evt_horror_festival_c1: 'Lead the festival',
  evt_horror_festival_r1: 'The festival was legendary! Massive rewards earned.',
  evt_legendary_review_name: 'Legendary Review',
  evt_legendary_review_desc: 'The world\'s most famous horror critic publishes a glowing review of your haunted house.',
  evt_legendary_review_c1: 'Bask in glory',
  evt_legendary_review_r1: 'A flood of 5-star reviews and fame follows!',

  // === Event Defense System ===
  evt_defense_badge: 'Auto-Resolved!',
  evt_defense_bonus: 'Bonus: +{sp} SP',
  evt_rain_defense: 'The roof upgrade keeps everyone dry. No one leaves!',
  evt_rain_hint: 'Tip: Upgrade Poster Wall to Lv.3 to auto-defend against rain.',
  evt_couple_fight_defense: 'Security steps in and mediates the situation calmly.',
  evt_couple_fight_hint: 'Tip: Hire a Security guard to auto-resolve fights.',
  evt_crying_child_defense: 'The snack cart attendant offers candy. The child smiles!',
  evt_crying_child_hint: 'Tip: Build a Snack Cart to automatically comfort crying children.',
  evt_blackout_defense: 'Emergency generators kick in automatically. No interruption!',
  evt_blackout_hint: 'Tip: Upgrade facilities to total Lv.10+ for backup power.',
  evt_line_cutter_defense: 'Security handles the line cutter immediately. Order restored!',
  evt_line_cutter_hint: 'Tip: Hire a Security guard to auto-handle line cutters.',
  evt_fake_ghost_defense: 'Your real NPC ghosts outshine the impostor. Excitement rises!',
  evt_fake_ghost_hint: 'Tip: Assign at least 1 NPC ghost to the lobby to overshadow fakers.',
  evt_lost_item_defense: 'Your staff quickly locates and returns the lost item!',
  evt_lost_item_hint: 'Tip: Hire 3+ staff members to auto-find lost items.',
  evt_snack_sold_out_defense: 'Inventory auto-restocked from reserves. Sales continue!',
  evt_snack_sold_out_hint: 'Tip: Upgrade Snack Cart to Lv.2+ for auto-restocking.',
  evt_sns_selfie_defense: 'Photo Zone provides the perfect backdrop. Great shots posted!',
  evt_sns_selfie_hint: 'Tip: Build a Photo Zone for automatic photo opportunities.',
  evt_hot_weather_defense: 'The monitor area has air conditioning. Everyone stays cool!',
  evt_hot_weather_hint: 'Tip: Install a TV Monitor to provide a cooled waiting area.',
  evt_tour_bus_defense: 'Plenty of room! All tourists are welcomed in.',
  evt_tour_bus_hint: 'Tip: Expand queue capacity to 15+ to accept large groups.',
  evt_tv_coverage_defense: 'With great reputation and many ghosts, the broadcast is a hit!',
  evt_tv_coverage_hint: 'Tip: Reach reputation 50+ and hire 5+ ghosts for guaranteed success.',
  evt_spy_defense: 'Security catches the spy red-handed! Intel recovered.',
  evt_spy_hint: 'Tip: Hire a Security guard to auto-detect spies.',
  evt_health_inspection_defense: 'Spotless! The inspector awards a hygiene certificate.',
  evt_health_inspection_hint: 'Tip: Hire a Janitor and keep average hygiene above 70.',
  evt_ghost_strike_defense: 'Ghosts are well-rested and happy. No strike today!',
  evt_ghost_strike_hint: 'Tip: Keep average ghost fatigue below 30 to prevent strikes.',
  evt_mystery_visitor_defense: 'Your excellent reputation earns a glowing review!',
  evt_mystery_visitor_hint: 'Tip: Maintain reputation at 60+ for guaranteed good reviews.',
  evt_maintenance_accident_defense: 'The repairman fixes it on the spot. Minimal damage!',
  evt_maintenance_accident_hint: 'Tip: Hire a Repairman to minimize equipment damage.',
  evt_total_blackout_defense: 'Repairman restores power instantly. Candle event bonus!',
  evt_total_blackout_hint: 'Tip: Hire a Repairman and reach facility Lv.15+ total.',
  evt_vip_party_defense: 'Costumes and photo zone make the party unforgettable! Normal business continues too.',
  evt_vip_party_hint: 'Tip: Build Costume Rental and Photo Zone for the ultimate party.',

  // === World Street ===
  world_title: 'Bangunan',
  world_subtitle: 'Pilih bangunan untuk dikelola',
  world_empty_plot: 'Lahan kosong',
  world_build_new: 'Bangun rumah hantu bertema baru',

  rename_building: 'Ganti nama gedung',
  rename_building_desc: 'Masukkan nama gedung baru',
  rename: 'Ubah',
  building_renamed: 'Nama gedung berhasil diubah',

  construction_title: 'Bangunan baru',
  construction_subtitle: 'Bangun rumah hantu baru!',
  construction_name_label: 'Nama gedung',
  construction_name_placeholder: 'Cth: Rumah tengah malam',
  construction_theme_label: 'Tema',
  construction_start: 'Bangun',
  world_status_build: 'Bangun',
  world_status_open: 'Buka',
  world_status_ready: 'Persiapan',
  theme_haunted_house: 'Rumah hantu',
  theme_haunted_house_desc: 'Pengalaman hantu klasik yang lucu',
  theme_abandoned_hospital: 'Rumah sakit terbengkalai',
  theme_abandoned_hospital_desc: 'Horor medis dan suasana laboratorium',
  theme_school_back_mountain: 'Gunung belakang sekolah',
  theme_school_back_mountain_desc: 'Cerita hantu sekolah dan jejak pegunungan',
  theme_cursed_circus: 'Sirkus Terkutuk',
  theme_cursed_circus_desc: 'Horor aneh dari tenda sirkus terkutuk',
  theme_ancient_temple: 'Kuil Kuno',
  theme_ancient_temple_desc: 'Kutukan mistis dari kuil kuno',
  theme_pirate_ship: 'Kapal Bajak Laut',
  theme_pirate_ship_desc: 'Horor laut dari kapal bajak laut terkutuk',
  theme_abandoned_mine: 'Tambang Terbengkalai',
  theme_abandoned_mine_desc: 'Horor gelap dari tambang terbengkalai',
  theme_gothic_castle: 'Kastil Gotik',
  theme_gothic_castle_desc: 'Horor aristokrat yang elegan dan mengerikan',
  theme_underground_bunker: 'Bunker Bawah Tanah',
  theme_underground_bunker_desc: 'Eksperimen dan konspirasi di bawah tanah',
  theme_cursed_forest: 'Hutan Terkutuk',
  theme_cursed_forest_desc: 'Roh alam dan horor primitif',

  synergy_active_count: '{n} Sinergi Aktif',
  synergy_popup_title: 'Sinergi Aktif',
  syn_fx_dark_mirror_e1: 'Ilusi Cermin',
  syn_fx_dark_mirror_e2: 'Kutukan Kembar',
  syn_fx_underground_horror_e1: 'Jeritan Penjara Bawah Tanah',
  syn_fx_underground_horror_e2: 'Gema Kematian',
  syn_fx_restless_spirits_e1: 'Tarikan Napas Orang Mati',
  syn_fx_restless_spirits_e2: 'Prosesi Hantu',
  syn_fx_creepy_collection_e1: 'Kutukan Boneka',
  syn_fx_creepy_collection_e2: 'Labirin Cermin',
  syn_fx_mad_scientist_e1: 'Eksperimen Gila',
  syn_fx_mad_scientist_e2: 'Hadiah Alkimia',
  syn_fx_hidden_paths_e1: 'Labirin Bayangan',
  syn_fx_hidden_paths_e2: 'Teror Tersembunyi',
  syn_fx_circus_nightmare_e1: 'Permainan Badut',
  syn_fx_circus_nightmare_e2: 'Mimpi Buruk Sirkus',
  syn_fx_ancient_curse_e1: 'Kutukan Kuno',
  syn_fx_ancient_curse_e2: 'Amukan Mummi',
  syn_fx_hidden_treasures_e1: 'Godaan Harta',
  syn_fx_hidden_treasures_e2: 'Penemuan Bawah Tanah',
  syn_fx_ship_of_doom_e1: 'Nyanyian Laut',
  syn_fx_ship_of_doom_e2: 'Hukuman Davy Jones',
  syn_fx_prison_horror_e1: 'Pelarian Penjara',
  syn_fx_prison_horror_e2: 'Belenggu Rantai',
  syn_fx_deep_descent_e1: 'Cahaya Kristal',
  syn_fx_deep_descent_e2: 'Misteri Bawah Tanah',
  syn_fx_boom_scare_e1: 'Dampak Ledakan',
  syn_fx_boom_scare_e2: 'Ledakan Berantai',
  syn_fx_royal_terror_e1: 'Amukan Raja',
  syn_fx_royal_terror_e2: 'Harta Karun Kerajaan',
  syn_fx_noble_cellar_e1: 'Aroma Anggur',
  syn_fx_noble_cellar_e2: 'Gudang Rahasia',
  syn_fx_quarantine_protocol_e1: 'Peringatan Karantina',
  syn_fx_quarantine_protocol_e2: 'Ancaman Biologis',
  syn_fx_nature_wrath_e1: 'Kabut Penyihir',
  syn_fx_nature_wrath_e2: 'Amukan Alam',
  syn_fx_ancient_power_e1: 'Kekuatan Kuno',
  syn_fx_ancient_power_e2: 'Reruntuhan Mistis',
  syn_fx_echo_chamber_e1: 'Kutukan Gema',
  syn_fx_echo_chamber_e2: 'Ilusi Suara',
  syn_fx_water_horror_e1: 'Teror Jurang',
  syn_fx_water_horror_e2: 'Bisikan Air',
  syn_fx_full_course_e1: 'Perjamuan Lengkap',
  syn_fx_full_course_e2: 'Senyum Kepuasan',
  synergy_dark_mirror: 'Cermin Gelap',
  synergy_dark_mirror_desc: 'Lorong Gelap + Ruang Cermin: Atmosfer+15%, Ketakutan+10%',
  synergy_underground_horror: 'Horor Bawah Tanah',
  synergy_underground_horror_desc: 'Penjara/Keranda: Ketakutan+20%, Seru+10%',
  synergy_restless_spirits: 'Arnak Gelisah',
  synergy_restless_spirits_desc: 'Kuburan/Keranda/Kamar Jenazah: Atmosfer+20%, Pengunjung+10%',
  synergy_creepy_collection: 'Koleksi Seram',
  synergy_creepy_collection_desc: 'Boneka/Cermin/Rumah Seru: Ketakutan+15%, Seru+10%',
  synergy_mad_scientist: 'Ilmuwan Gila',
  synergy_mad_scientist_desc: 'Lab/Ruang Bedah/Sains: Seru+20%, SP+15%',
  synergy_hidden_paths: 'Jalan Tersembunyi',
  synergy_hidden_paths_desc: 'Lorong Rahasia/Lorong/Loteng: Atmosfer+15%, Rantai+20%',
  synergy_circus_nightmare: 'Mimpi Buruk Sirkus',
  synergy_circus_nightmare_desc: 'Rumah Seru/Pertunjukan Ajaib/Trapeze: Keseruan+20%, Ketakutan+15%',
  synergy_ancient_curse: 'Kutukan Kuno',
  synergy_ancient_curse_desc: 'Altar/Ruang Kutukan/Makam Mummi: Ketakutan+25%, Seru+15%',
  synergy_hidden_treasures: 'Harta Karun',
  synergy_hidden_treasures_desc: 'Brankas + Sungai Bawah Tanah: SP+20%, Pengunjung+10%',
  synergy_ship_of_doom: 'Kapal Kematian',
  synergy_ship_of_doom_desc: 'Kabin Kapal/Kargo/Davy: Atmosfer+15%, Ketakutan+15%',
  synergy_prison_horror: 'Horor Penjara',
  synergy_prison_horror_desc: 'Sel Kapal + Davy: Seru+20%, Ancaman+10%',
  synergy_deep_descent: 'Penurunan Dalam',
  synergy_deep_descent_desc: 'Tambang/Gua Kristal/Danau: Atmosfer+20%, Pengunjung+15%',
  synergy_boom_scare: 'Ledakan Seru',
  synergy_boom_scare_desc: 'Gudang Peledak + Terowongan: Seru+25%, Rantai+15%',
  synergy_royal_terror: 'Teror Kerajaan',
  synergy_royal_terror_desc: 'Tahta/Menara/Anggur: Ketakutan+15%, SP+20%',
  synergy_noble_cellar: 'Gudang Bangsawan',
  synergy_noble_cellar_desc: 'Gudang Anggur + Lorong Rahasia: Atmosfer+15%, SP+10%',
  synergy_quarantine_protocol: 'Protokol Karantina',
  synergy_quarantine_protocol_desc: 'Server/Karantina/Senjata: Seru+20%, Ketakutan+10%',
  synergy_nature_wrath: 'Kemarahan Alam',
  synergy_nature_wrath_desc: 'Penyihir/Rawa/Peri: Atmosfer+20%, Ancaman+10%',
  synergy_ancient_power: 'Kekuatan Kuno',
  synergy_ancient_power_desc: 'Reruntuhan/Peri/Altar: Ketakutan+20%, Pengunjung+15%',
  synergy_echo_chamber: 'Ruang Gema',
  synergy_echo_chamber_desc: 'Musik/Perpustakaan/Lorong: Rantai+25%, Atmosfer+10%',
  synergy_water_horror: 'Horor Air',
  synergy_water_horror_desc: 'Kamar Mandi/Sungai/Danau: Ketakutan+15%, Atmosfer+15%',
  synergy_full_course: 'Paket Lengkap',
  synergy_full_course_desc: 'Dapur/Kamar Mandi/Musik: Keseruan+25%, Pengunjung+20%',
};

export default id;
